module.exports = __webpack_public_path__ + "static/wickham_terrace-73cc8f5426042be8a31a1ddc28541c3d.svg";